import React from "react";
import Autocomplete from "../../autocomplete";

export default function SearchFilterAutoComplete({ filterOptions, searchType, onSearchValueChange, setAutocompleteInput, autocompleteInput }) {
    const suggestions = filterOptions[searchType.key];
    const onSelect = (suggestion) => {
        onSearchValueChange(suggestion);
        setAutocompleteInput(suggestion);
    };

    const onChange = (value) => {
        if (!value.length) onSearchValueChange(value);
        setAutocompleteInput(value);
    };

    return (
        <Autocomplete
            suggestions={suggestions}
            filterSuggestions={true}
            onSelect={onSelect}
            inputValue={autocompleteInput}
            onChange={(value) => onChange(value)}
        />
    );
}
